import type { MouseEvent } from 'react';
import cx from 'clsx';
import { trackEvent } from '@kcd/event-tracker';

import type { OAISchema } from '~/types/openapi';

import styles from './index.module.css';

interface Props {
  product: OAISchema['MarketSelectProductResponseV2'];
  onClickHandler?: () => void;
  disabled?: boolean;
  className?: string;
  ctaText?: string;
}

const ECouponProductPurchaseButton = ({
  product,
  onClickHandler,
  disabled = false,
  className,
  ctaText,
}: Props) => {
  const onClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();

    trackEvent('clicked purchaseButton in 마켓', {
      placement: '상품목록',
      productName: product.productName,
      offerId: product.offerId,
      path: window.location.pathname,
    });

    onClickHandler?.();
  };
  return (
    <button
      type="button"
      className={cx([styles.button, className])}
      disabled={disabled}
      onClick={onClick}
    >
      {ctaText || '바로구매'}
    </button>
  );
};

export default ECouponProductPurchaseButton;
